import React from "react";
import { CheckIcon, RadioIcon } from "./icons";

export const PLAN_CONFIGS = {
  PREMIUM: {
    name: "Premium",
    monthly: {
      price: 19.99,
      yearlyTotal: 239.88,
      subtitle: "Billed $19.99 per month, $239.88 per year",
    },
    annual: {
      price: 15.99,
      yearlyTotal: 191.88,
      subtitle: "Billed $191.88 per year, $15.99 per month",
    },
    features: [
      "20,000 words monthly",
      "1,000 words per request",
      "Advanced AI detection",
      "Generator access",
      "Forever results history",
      "Standard customer support",
    ],
  },
  PRO: {
    name: "Pro",
    monthly: {
      price: 34.99,
      yearlyTotal: 419.88,
      subtitle: "Billed $34.99 per month, $419.88 per year",
    },
    annual: {
      price: 28.99,
      yearlyTotal: 347.88,
      subtitle: "Billed $347.88 per year, $28.99 per month",
    },
    features: [
      "40,000 words monthly",
      "2,500 words per request",
      "Advanced AI detection",
      "Generator access",
      "Forever results history",
      "Priority support dedicated manager",
    ],
  },
};

export default function PlanCard({
  planKey = "PREMIUM",
  isActive = false,
  isMonthly = true,
  isDark = false,
  onClick,
  maxFeatures,
}) {
  const plan = PLAN_CONFIGS[planKey];
  const billing = isMonthly ? plan.monthly : plan.annual;
  const displayFeatures = maxFeatures
    ? plan.features.slice(0, maxFeatures)
    : plan.features;

  // Colors based on state
  const bgColor = isActive
    ? "bg-[#4D47DC]"
    : isDark
    ? "bg-[#212121]"
    : "bg-white";

  const borderColor = isActive
    ? "border-transparent"
    : isDark
    ? "border-white-alpha-15"
    : "border-black-alpha-15";

  const dividerColor = isActive
    ? "border-white-alpha-15"
    : isDark
    ? "border-white-alpha-15"
    : "border-black-alpha-15";

  const textPrimary = isActive
    ? "text-white"
    : isDark
    ? "text-white"
    : "text-[#0D0D0D]";

  const textSecondary = isActive
    ? "text-white/60"
    : isDark
    ? "text-[#ABABAB]"
    : "text-[#5D5D5D]";

  const textTertiary = isActive
    ? "text-white"
    : isDark
    ? "text-white"
    : "text-[#09090B]";

  const checkColor = isActive
    ? "stroke-white"
    : isDark
    ? "stroke-[#ABABAB]"
    : "stroke-[#5D5D5D]";

  return (
    <div
      onClick={onClick}
      className={`
        flex-1 rounded-xl border p-12 md:p-18 cursor-pointer
        transition-all duration-200
        ${bgColor} ${borderColor}
      `}
    >
      <div className="flex items-center">
        <div className="flex items-start w-full gap-10">
          <RadioIcon isActive={isActive} className="mt-6" />
          <div className={`flex flex-1 flex-col gap-8`}>
            <div className="flex items-center justify-between">
              <p
                className={`font-semibold text-[16px] leading-[1.20em] tracking-[-2%] ${textPrimary}`}
              >
                {plan.name}
              </p>
              <div className="flex items-baseline gap-2">
                <span
                  className={`font-bold text-[24px] leading-[1.16em] tracking-[-1%] ${textPrimary}`}
                >
                  ${billing.price}
                </span>
                <span
                  className={`font-medium text-[12px] leading-[1.33em] ${textSecondary}`}
                >
                  /
                </span>
                <span
                  className={`font-medium text-[12px] leading-[1.33em] ${textSecondary}`}
                >
                  m
                </span>
              </div>
            </div>
            <p
              className={`text-[13px] leading-[1.38em] tracking-[-1%] border-b pb-8 ${dividerColor} ${textPrimary}`}
            >
              {billing.subtitle}
            </p>
            {/* Features List */}
            <div className="flex flex-col gap-12">
              {displayFeatures.map((feature, index) => (
                <div key={index} className="flex items-center gap-12">
                  <CheckIcon className={checkColor} />
                  <span
                    className={`text-[14px] md:text-[16px] leading-[1.43em] tracking-[-1%] font-medium ${textTertiary}`}
                  >
                    {feature}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
